import {
  CATALOG_ENTRIES_DEFAULTS,
  hideCE10Props,
} from "@stadium/shared/src/helpers/plasmic/static-slices";

const CE10_DEFAULTS = CATALOG_ENTRIES_DEFAULTS.CE10;

export const CE10_PLASMIC_PROPS = {
  contentHeading: {
    type: "string",
    defaultValue: CE10_DEFAULTS.contentHeading,
    description: "Content box heading - desktop/tablet only (CE-10 only)",
    hidden: hideCE10Props,
  },
  contentDescription: {
    type: "string",
    defaultValue: CE10_DEFAULTS.contentDescription,
    description: "Content box description - desktop/tablet only (CE-10 only)",
    hidden: hideCE10Props,
  },
  cards: {
    type: "array",
    defaultValue: CE10_DEFAULTS.cards,
    description: "Card items (CE-10 only)",
    itemType: {
      type: "object",
      fields: {
        id: {
          type: "string",
          description: "Card identifier",
        },
        title: {
          type: "string",
          description: "Card title",
        },
        description: {
          type: "string",
          description: "Card description",
        },
        buttonText: {
          type: "string",
          description: "Card button text",
        },
        buttonUrl: {
          type: "string",
          description: "Card button URL",
        },
        image: {
          type: "imageUrl",
          description: "Card image",
        },
        imageAlt: {
          type: "string",
          description: "Card image alt text",
        },
      },
    },
    hidden: hideCE10Props,
  },
  backgroundColor: {
    type: "string",
    defaultValue: CE10_DEFAULTS.backgroundColor,
    description: "Background color (CE-10 only)",
    hidden: hideCE10Props,
  },
};
